import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Panel, PanelHeader, PanelBody, PanelFooter } from '../../components/panel/panel.jsx';
import { toast } from 'react-toastify'; 
import axios from 'axios'
import Pagination from '../../components/pagination/pagination.jsx';
import Modal from 'react-modal';
import moment from 'moment/moment.js';
import StatusForm from './courierStatus.jsx';

import ModalWithProceed from '../../components/prompt/ModalWithProceed.jsx';
import { isEmpty } from "../../helper/helper.js"

function CourierStatusList({ props = {} }) {

  const [dataTable, setDataTable] = useState([])
  const [state, setState] = useState({});
  const [formData, setFormData] = useState({ currentPage: 1, rowsPerPage: 50 });
  const [formIsOpen, setFormIsOpen] = useState(false);
  const [modalUid, setModalUid] = useState('')

  const [promptDeleteIsOpen, setPromptDeleteIsOpen] = useState(false);

  const handleOnChangeInputText = (e) => {
    const { name, value } = e.target
    setState(prevState => ({
      ...prevState,
      [name]: value
    }))
  }

  const onChangePageHandler = async (page) => {
    setFormData(prevState => ({ ...prevState, currentPage: page }))
    await refreshTable(page)
  }

  const onChangePageSelectHandler = async (e) => {
    setFormData(prevState => ({ ...prevState, rowsPerPage: e.target.value }))
    await refreshTable(state.currentPage, e.target.value)
  }

  const openStatusForm = async (uid, e) => {
    e.preventDefault();
    setModalUid(uid)
    setFormIsOpen(true)

  }

  const confirmDeleteServiceType = async() => { 
    setPromptDeleteIsOpen(false)
  
    if (isEmpty(formData.id)) {
      return
    }
 

    await axios.delete(`${window.API_HOST}/v1/courier-status/${formData.id}`)
      .then(res => {
        const resp = res.data;
 
        toast.success(`Success delete status ${formData.name}`)
        refreshTable()

      }).catch(err => {
        toast.error( err.response?.data?.error ?? `Can't delete ${formData.name}`)

      })  
  }

  const refreshTable = async (_page, _size) => {

    let params = {
      page: _page ?? formData.currentPage,
      size: _size ?? formData.rowsPerPage,
      serviceType: state.serviceType ?? '',
    }

    for (var key in params) {
      if (isEmpty(params[key])) {
        delete params[key]
      }
    }
    
    await axios.get(`${window.API_HOST}/v1/courier-status`, { params })
      .then(res => {
        setDataTable(res.data?.data ?? [])
        setFormData(prevState => ({
          ...prevState,
          totalRows: res.data.meta.total
        }))

      }).catch(err => {

      })
  }

  const searchForm = async () => {
    await refreshTable(1)
  }


  useEffect(() => {
    searchForm()
  }, []) //eslint-disable-next-line 


  const customStyles = {
    content: {
      top: '30%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
    },
  };

  return (
    <div>
      <ol className="breadcrumb float-xl-end">
        <li className="breadcrumb-item"><Link to="/home"><i className='fa fa-home'></i> Home</Link></li>
      </ol>
      <h1 className="page-header">Courier Status Mapping<small></small></h1>
      <Panel>
        <PanelHeader noButton>Courier Status Mapping List</PanelHeader>
        <PanelBody>
          <div className='row'>
            <div className='col-sm-4'>
              <div className="form-group row mb-1">
                <label className="col-sm-3 col-form-label">Courier</label>
                <div className="col-sm-9">
                  <input type="text" name="statusDescr" value={state.statusDescr ?? ""} onChange={handleOnChangeInputText} className="form-control form-control-sm" />
                </div>
              </div>
              <div className="form-group row my-2">
                <label className="col-sm-3 col-form-label">&nbsp;</label>
                <div className="col-sm-8">
                  <button type="button" className="btn btn-sm btn-primary me-2" onClick={searchForm}><span className="fa fa-sm fa-search"></span> Search</button>
                  <button type="button" className="btn btn-sm btn-primary me-2" onClick={() => { }}><span className="fa fa-sm fa-download"></span> Download</button>
                  <button type="button" className="btn btn-sm btn-primary me-2" onClick={(e) => { openStatusForm(null, e) }}><span className="fa fa-plus-circle fa-sm"></span> New</button>
                </div>
              </div>
            </div>
          </div>
        </PanelBody>
      </Panel>
      <Panel>
        <PanelBody>
          <div className="table table-hover mb-0 text-dark">
            <table className="table table-sm table-hover table-striped mb-0 text-dark">
              <thead className='bg-lime-400 fw-bold'>
                <tr>
                  <th>No.</th>
                  <th className='w-90px'>Courier</th>
                  <th>Status Code</th>
                  <th>Status Descr</th>
                  <th>Mapping To</th> 
                  <th>Updated At</th>
                  <th>Updated By</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {(dataTable).map((val, key) => {
                  return (
                    <tr className='fs-8 fw-light' key={key}>
                      <td>{((formData.currentPage - 1) * formData.rowsPerPage) + (key + 1)}.</td>
                      <td>{val.courier_code}</td>
                      <td>{val.courier_status}</td>
                      <td>{val.courier_status_descr}</td> 
                      <td>{val.status_id} - {val.status_code}</td> 
                      <td>{moment(val.updated_at).format('YYYY-MM-DD HH-mm:ss')}</td>
                      <td>{val.updated_by}</td>
                      <td><button className='btn btn-xs me-3' onClick={(e) => { openStatusForm(val.id, e) }}><i className='fa fa-pen-to-square'></i></button> <button className='btn btn-xs'><i className='fa fa-trash text-danger' onClick={() => {
                        setFormData(prevState=>({
                          ...prevState,
                          name: `${val.courier_code}-${val.courier_status}`,
                          id: val.id
                        }))
                        setPromptDeleteIsOpen(true);
                        }}></i></button></td>
                    </tr>)
                })}
              </tbody>
            </table>
          </div>
        </PanelBody>
        <PanelFooter>
          <div className='row'>
            <div className="col-sm-12">
              <Pagination
                currentPage={formData.currentPage ?? 1}
                totalRows={formData.totalRows ?? 1}
                pageSize={formData.rowsPerPage ?? 50}
                onPageChange={onChangePageHandler}
                selectedPageHandler={onChangePageSelectHandler}
              />
            </div>
          </div>
        </PanelFooter>
      </Panel>
      <>
        <Modal
          isOpen={formIsOpen}
          onAfterOpen={() => { }}
          onRequestClose={() => setFormIsOpen(false)}
          style={customStyles}
          ariaHideApp={false}  >
          <StatusForm props={{
            uid: modalUid, cancelAction: () => {
              setFormIsOpen(false)
            }
          }} />
        </Modal>

        
        <ModalWithProceed header={false} show={promptDeleteIsOpen} close={() => { setPromptDeleteIsOpen(false) }} proceed={confirmDeleteServiceType}>
          Do you want to delete <strong>{formData.name}</strong> ?
        </ModalWithProceed>

      </>


    </div>
  )
}

export default CourierStatusList;